var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveMapLegend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Map_Legend_250121",
    "data-name": "noun_Map Legend_250121",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.788,
    height: 22.32,
    viewBox: "0 0 30.788 22.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M34.512,24.823H54.385a.612.612,0,1,0,0-1.223H34.512a.612.612,0,1,0,0,1.223Z",
    transform: "translate(-24.209 -21.324)",
    fill: "#0ccfe8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M54.352,47.3H34.512a.612.612,0,1,0,0,1.223H54.385A.609.609,0,0,0,55,47.912.639.639,0,0,0,54.352,47.3Z",
    transform: "translate(-24.209 -36.972)",
    fill: "#0ccfe8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M54.352,70.9H34.512a.612.612,0,0,0,0,1.223H54.385A.609.609,0,0,0,55,71.512.639.639,0,0,0,54.352,70.9Z",
    transform: "translate(-24.209 -52.555)",
    fill: "#0ccfe8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M11.475,39.7H6.312a.609.609,0,0,0-.612.612v5.164a.609.609,0,0,0,.612.612h5.164a.609.609,0,0,0,.612-.612V40.312A.657.657,0,0,0,11.475,39.7Z",
    transform: "translate(-5.59 -31.954)",
    fill: "#0ccfe8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M5.961,22.709h5.3a.56.56,0,0,0,.51-.306.65.65,0,0,0,0-.612L9.12,17.206a.631.631,0,0,0-.51-.306.56.56,0,0,0-.51.306l-2.65,4.62a.649.649,0,0,0,0,.612A.531.531,0,0,0,5.961,22.709Z",
    transform: "translate(-5.375 -16.9)",
    fill: "#0ccfe8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M8.8,62.6a3.4,3.4,0,1,0,3.4,3.4A3.407,3.407,0,0,0,8.8,62.6Z",
    transform: "translate(-5.392 -47.075)",
    fill: "#0ccfe8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMapLegend);
export default __webpack_public_path__ + "static/media/activeMapLegend.194fc8c52f61d8993661a64487bc7631.svg";
export { ForwardRef as ReactComponent };